module.exports = __webpack_public_path__ + "img/circle2.7b9968bb.gif";